export const SET_USERNAME = "SET_USERNAME";
export const SET_PASSWORD = "SET_PASSWORD";
export const GET_DETAILS = "GET_DETAILS";
